/* tslint:disable */
/* eslint-disable */
/**
 * Sds Web
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProductInfo
 */
export interface ProductInfo {
    /**
     * 
     * @type {number}
     * @memberof ProductInfo
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof ProductInfo
     */
    shortText?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProductInfo
     */
    displayName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProductInfo
     */
    retailerId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProductInfo
     */
    icon?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProductInfo
     */
    dynamicType?: string | null;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof ProductInfo
     */
    filters?: { [key: string]: string; } | null;
}

export function ProductInfoFromJSON(json: any): ProductInfo {
    return ProductInfoFromJSONTyped(json, false);
}

export function ProductInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProductInfo {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'shortText': !exists(json, 'shortText') ? undefined : json['shortText'],
        'displayName': !exists(json, 'displayName') ? undefined : json['displayName'],
        'retailerId': !exists(json, 'retailerId') ? undefined : json['retailerId'],
        'icon': !exists(json, 'icon') ? undefined : json['icon'],
        'dynamicType': !exists(json, 'dynamicType') ? undefined : json['dynamicType'],
        'filters': !exists(json, 'filters') ? undefined : json['filters'],
    };
}

export function ProductInfoToJSON(value?: ProductInfo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'shortText': value.shortText,
        'displayName': value.displayName,
        'retailerId': value.retailerId,
        'icon': value.icon,
        'dynamicType': value.dynamicType,
        'filters': value.filters,
    };
}


